module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-2.37462b20.jpg";